import { AgentStreamEventModel } from '~/models';
const SUPPRESSED_TOOL_NAMES = new Set([
    'submitEnvelope'
]);
const MAX_ACK_TEXT_LENGTH = 500;
export const createAgentStreamParser = ()=>{
    const inFlightTools = new Map();
    return (raw)=>{
        if (raw.data === '[DONE]') return null;
        const data = raw.data ? JSON.parse(raw.data) : {};
        const eventType = data.type;
        const nested = data.data;
        const dto = resolveDto(eventType, nested, raw, data, inFlightTools);
        return dto == null ? null : AgentStreamEventModel.fromDTO(dto);
    };
};
const resolveDto = (eventType, nested, raw, data, inFlightTools)=>{
    switch(eventType){
        case 'data-message':
            return {
                type: 'message',
                message: nested === null || nested === void 0 ? void 0 : nested.message
            };
        case 'data-error':
            return {
                type: 'error',
                error: nested === null || nested === void 0 ? void 0 : nested.error
            };
        case 'data-draft':
            return {
                type: 'draft-created',
                draftId: nested === null || nested === void 0 ? void 0 : nested.draftId
            };
        case 'data-ack':
            {
                const rawText = nested === null || nested === void 0 ? void 0 : nested.text;
                const text = typeof rawText === 'string' ? rawText.slice(0, MAX_ACK_TEXT_LENGTH) : '';
                return {
                    type: 'ack',
                    text
                };
            }
        case 'data-message-enrichment':
            {
                const messageId = nested === null || nested === void 0 ? void 0 : nested.messageId;
                if (messageId == null) return null;
                const contentPatch = resolveContentPatch(nested);
                if (contentPatch == null) return null;
                return {
                    type: 'message-enrichment',
                    messageId,
                    contentPatch
                };
            }
        case 'tool-input-start':
            {
                const toolCallId = data.toolCallId;
                const toolName = data.toolName;
                if (toolCallId == null || toolName == null) return null;
                if (SUPPRESSED_TOOL_NAMES.has(toolName)) return null;
                inFlightTools.set(toolCallId, {
                    toolName,
                    startedAt: Date.now()
                });
                return {
                    type: 'tool-call-start',
                    tool: toolName,
                    args: {}
                };
            }
        case 'tool-output-available':
        case 'tool-output-error':
        case 'tool-output-denied':
        case 'tool-input-error':
            {
                const toolCallId = data.toolCallId;
                if (toolCallId == null) return null;
                const entry = inFlightTools.get(toolCallId);
                if (entry == null) return null;
                inFlightTools.delete(toolCallId);
                return {
                    type: 'tool-call-end',
                    tool: entry.toolName,
                    durationMs: Date.now() - entry.startedAt
                };
            }
        case 'data-reset':
            inFlightTools.clear();
            return {
                type: 'reset'
            };
        case 'start':
        case 'start-step':
        case 'finish-step':
        case 'finish':
        case 'text-start':
        case 'text-delta':
        case 'text-end':
        case 'reasoning-start':
        case 'reasoning-delta':
        case 'reasoning-end':
        case 'tool-input-delta':
        case 'tool-input-available':
        case 'tool-approval-request':
        case 'source':
        case 'message-metadata':
        case 'data-status':
            return null;
        default:
            // eslint-disable-next-line no-console
            console.warn("unknown SSE event type: ".concat(eventType), {
                raw,
                data
            });
            return null;
    }
};
// WHY: legacy `{ followUp }` fallback covers in-flight agentic frames from the not-yet-upgraded backend during FE-first rollout.
const resolveContentPatch = (nested)=>{
    const contentPatch = nested === null || nested === void 0 ? void 0 : nested.contentPatch;
    if (contentPatch != null) return contentPatch;
    const legacyFollowUp = nested === null || nested === void 0 ? void 0 : nested.followUp;
    if (legacyFollowUp != null) return {
        followUp: legacyFollowUp
    };
    return null;
};
